import React from "react";
import PageWrapper from "../components/PageWrapper";
import "./css/Contact.css"; // Reuse the same styling
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | GTAFanPage.com</title>
        <meta
          name="description"
          content="Learn how GTAFanPage.com collects, uses, and protects your personal data. Review our privacy practices and your rights."
        />
        <link
          rel="canonical"
          href="https://www.gtafanpage.com/privacy-policy"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Privacy Policy | GTAFanPage.com" />
        <meta
          property="og:description"
          content="Read GTAFanPage.com's privacy policy covering data collection, usage, third-party sharing, and user rights."
        />
        <meta
          property="og:url"
          content="https://www.gtafanpage.com/privacy-policy"
        />
        <meta
          property="og:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | GTAFanPage.com" />
        <meta
          name="twitter:description"
          content="Review how GTAFanPage.com handles your personal data, privacy rights, and cookie usage."
        />
        <meta
          name="twitter:image"
          content="https://www.gtafanpage.com/og-image.jpg"
        />

        {/* JSON-LD Structured Data for Legal Policy */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Privacy Policy",
            url: "https://www.gtafanpage.com/privacy-policy",
            description:
              "Details on how GTAFanPage.com collects, uses, and protects your personal information. Includes data privacy practices and user rights.",
            publisher: {
              "@type": "Organization",
              name: "GTAFanPage",
              url: "https://www.gtafanpage.com",
              logo: {
                "@type": "ImageObject",
                url: "https://www.gtafanpage.com/logo192.png",
              },
            },
          })}
        </script>
      </Helmet>

      <PageWrapper>
        <div className="contact-page-wrapper">
          <div className="contact-card">
            <h2>Privacy Policy</h2>
            <p>
              GTAFanPage.com respects your privacy. We collect limited personal
              information such as your name, email, and IP address for account
              creation and site analytics.
            </p>
            <p>
              We use cookies to enhance your experience, provide secure access,
              and serve relevant ads. Your data may be shared with third-party
              analytics and advertising partners.
            </p>
            <p>
              We do not sell personal information and will never disclose it
              unless required by law or to protect our services. You can request
              deletion or modification of your data at any time.
            </p>
            <p>
              For children under 13, we do not knowingly collect personal data.
              If you believe we have collected such information, please contact
              us for immediate removal.
            </p>
            <p>
              For privacy-related inquiries, reach out to us at{" "}
              <Link to="/contact" className="contact-link">
                Contact Us
              </Link>{" "}
              to send us a message.
            </p>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default Privacy;
